import isEqual from 'lodash/isEqual';
import React from 'react';
import { useForm } from 'react-final-form';

import UnsavedChangesModal from '../UnsavedChangesModal/UnsavedChangesModal';

export type CampaignFormUnsavedChangesModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const CampaignFormUnsavedChangesModal = ({ isOpen, setIsOpen }: CampaignFormUnsavedChangesModalProps) => {
  const form = useForm();

  return (
    <UnsavedChangesModal
      isOpen={isOpen}
      onDropChanges={(history, nextLocation) => {
        setIsOpen(false);
        if (nextLocation) {
          history.push(nextLocation.pathname, { forceRouteChange: true });
        }
      }}
      onRouteChangeBlock={() => {
        const { values, initialValues, dirtyFieldsSinceLastSubmit } = form.getState();

        const shouldBlock = !isEqual(values, initialValues) && Object.values(dirtyFieldsSinceLastSubmit).length > 0;

        if (shouldBlock) {
          setIsOpen(true);
          return false;
        }

        return;
      }}
      onClose={() => setIsOpen(false)}
    />
  );
};
